let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6LeQg")).then(() => parcelRequire('eRFmF'));